import { Button, TYPE_BUTTON } from '@eventbrite/eds-button';
import { gettext } from '@eventbrite/i18n';
import React from 'react';

interface PromoCodeCtaButtonProps {
    isDisabled: boolean;
    onClick: () => void;
}

export const PromoCodeCtaButton: React.FunctionComponent<
    PromoCodeCtaButtonProps
> = ({ isDisabled, onClick }) => (
    <Button
        data-automation="checkout-widget-submit-promo-button"
        data-spec="promo-code-form-cta-button"
        data-testid="promo-code-form-cta-button"
        disabled={isDisabled}
        onClick={onClick}
        size="block"
        style="fill"
        type={TYPE_BUTTON}
    >
        {gettext('Apply')}
    </Button>
);
